import { render, staticRenderFns } from "./EnacCustomAtplResourceLinks.vue?vue&type=template&id=f13ae464"
import script from "./EnacCustomAtplResourceLinks.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplResourceLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports